import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth.js'
import store from '@/store/'

import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Login from '@/views/Login.vue'
import Panel from '@/views/Panel.vue'
import Dashboard from '@/views/Dashboard.vue'
import Users from '@/views/Users.vue'
import Clients from '@/views/Clients.vue'

import UserForm from '@/views/UserForm.vue'
import User from '@/views/User.vue'

import Organizations from '@/views/Organizations.vue'
import Organization from '@/views/Organization.vue'
import OrganizationForm from '@/views/OrganizationForm.vue'
import OrganizationRegisterForm from '@/views/OrganizationRegisterForm.vue'

import Suppliers from '@/views/Suppliers.vue'
import SupplierForm from '@/views/SupplierForm.vue'
import SupplierRegisterForm from '@/views/SupplierRegisterForm.vue'

import Products from '@/views/Products.vue'
import ProductForm from '@/views/ProductForm.vue'
import ProductVariationForm from '@/views/ProductVariationForm.vue'

import Offers from '@/views/Offers.vue'
import OfferForm from '@/views/OfferForm.vue'

import CollectiveOfferForm from '@/views/CollectiveOfferForm.vue'
import CollectiveOffers from '@/views/CollectiveOffers.vue'
import CollectiveOffer from '@/views/CollectiveOffer.vue'
import CollectiveShop from '@/views/CollectiveShop.vue'

import Orders from '@/views/Orders.vue'
import Order from '@/views/Order.vue'

import Invoices from '@/views/Invoices.vue'

import Demands from '@/views/Demands.vue'
import Demand from '@/views/Demand.vue'

import Site from '@/views/Site.vue'
import Ecommerce from '@/views/Ecommerce.vue'
import Shop from '@/views/Shop.vue'
import Offer from '@/views/Offer.vue'
import Cart from '@/views/Cart.vue'

import ContentForm from '@/views/ContentForm.vue'
import Content from '@/views/Content.vue'
import BannerForm from '@/views/BannerForm.vue'

import Reports from '@/views/Reports.vue'


Vue.use(Router)

function requireAuth(to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
  } else {
    next()
  }
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/logout',
      beforeEnter(to, from, next) {
        auth.logout(() => {
          store.dispatch('logout')
          next('/')
        })
      }
    },
    {
      path: '/site',
      component: Site,
      children: [
        {
          path: '/login',
          component: Login
        },
        {
          path: '/about',
          component: About
        },
      ]
    },
    {
      path: '/panel',
      component: Panel,
      beforeEnter: requireAuth,
      children: [{
          path: '/painel',
          component: Dashboard,
          beforeEnter: requireAuth
        },
        {
          path: '/usuarios',
          component: Users,
          beforeEnter: requireAuth
        },
        {
          path: '/clientes',
          component: Clients,
          beforeEnter: requireAuth
        },

        {
          name: 'cadastrar-usuario',
          path: '/cadastrar-usuario',
          component: UserForm,
          beforeEnter: requireAuth
        },
        {
          path: '/editar-usuario/:id',
          component: UserForm,
          beforeEnter: requireAuth
        },
        {
          path: '/usuario/:id',
          component: User,
          beforeEnter: requireAuth
        },

        {
          path: '/redes',
          component: Organizations,
          beforeEnter: requireAuth
        },
        {
          path: '/cadastrar-rede',
          component: OrganizationRegisterForm,
          beforeEnter: requireAuth
        },
        {
          path: '/editar-rede/:id',
          component: OrganizationForm,
          beforeEnter: requireAuth
        },
        {
          path: '/rede/:id',
          component: Organization,
          beforeEnter: requireAuth
        },

        {
          path: '/fornecedores',
          component: Suppliers,
          beforeEnter: requireAuth
        },
        {
          path: '/cadastrar-fornecedor',
          component: SupplierRegisterForm,
          beforeEnter: requireAuth
        },
        {
          path: '/editar-fornecedor/:id',
          component: SupplierForm,
          beforeEnter: requireAuth
        },

        {
          path: '/produtos',
          component: Products,
          beforeEnter: requireAuth
        },
        {
          path: '/cadastrar-produto',
          component: ProductForm,
          beforeEnter: requireAuth
        },
        {
          path: '/editar-produto/:id',
          component: ProductForm,
          beforeEnter: requireAuth
        },

        {
          path: '/cadastrar-variacao-de-produto',
          component: ProductVariationForm,
          beforeEnter: requireAuth
        },
        {
          path: '/editar-variacao-de-produto/:id',
          component: ProductVariationForm,
          beforeEnter: requireAuth
        },

        {
          path: '/ofertas',
          component: Offers,
          beforeEnter: requireAuth
        },
        {
          path: '/cadastrar-oferta',
          component: OfferForm,
          beforeEnter: requireAuth
        },
        {
          path: '/editar-oferta/:id',
          component: OfferForm,
          beforeEnter: requireAuth
        },

        {
          path: '/ofertas-coletivas',
          component: CollectiveOffers,
          beforeEnter: requireAuth
        },
        {
          path: '/editar-oferta-coletiva/:id',
          component: CollectiveOfferForm,
          beforeEnter: requireAuth
        },

        {
          path: '/pedidos',
          component: Orders,
          beforeEnter: requireAuth
        },
        {
          path: '/pedido/:id',
          component: Order,
          beforeEnter: requireAuth
        },

        {
          path: '/boletos',
          component: Invoices,
          beforeEnter: requireAuth
        },

        {
          path: '/demandas',
          component: Demands,
          beforeEnter: requireAuth
        },
        {
          path: '/demanda/:id',
          component: Demand,
          beforeEnter: requireAuth
        },

        {
          path: '/editar-conteudo/:slug',
          component: ContentForm,
          beforeEnter: requireAuth
        },
        {
          path: '/editar-banner',
          component: BannerForm,
          beforeEnter: requireAuth
        },

        {
          path: '/relatorios',
          component: Reports,
          beforeEnter: requireAuth
        },
      ]
    },
    {
      path: '/ecommerce',
      component: Ecommerce,
      children: [{
          path: '/entrar',
          component: Login
        },
        {
          path: '/loja',
          component: Shop
        },
        {
          path: '/loja/:organization_id',
          component: Shop
        },
        {
          path: '/compras-coletivas',
          component: CollectiveShop
        },
        {
          path: '/oferta/:id',
          component: Offer
        },
        {
          path: '/oferta-coletiva/:id',
          component: CollectiveOffer
        },
        {
          path: '/carrinho',
          component: Cart
        },
        {
          path: '/conteudo/:slug',
          component: Content
        },
      ],
    },
  ]
})
